import { Dialog, Transition } from "@headlessui/react";
import { useFormik } from "formik";
import { Fragment, useState } from "react";
import * as Yup from "yup";
import groupService from "../../services/groupService";
import { LoadingSpinner } from "../Commons";

export default function CreateGroupModal(props) {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .min(3, "Required at least 3 characters")
        .required("Required"),
    }),
    onSubmit: async (values) => createAPIKeyHandler(values),
  });

  async function createAPIKeyHandler(values) {
    setLoading(true);
    groupService.createGroup(values).then(data => {
      props.createHandler(data);
      setLoading(false);
      formik.resetForm();
    });
  };

  const handleCancel = () => {
    formik.resetForm();
    props.createHandler();
  };

  return (
    <Transition.Root show={props.show} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => null}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                <form onSubmit={formik.handleSubmit}>
                  <div className="bg-white mx-6 my-3">
                    <div className="sm:flex sm:items-start">
                      <div className="mt-3 w-full text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-lg leading-6 font-medium text-gray-900"
                        >
                          Create Group
                        </Dialog.Title>
                        <div className="mt-2 w-full">
                          <div className="">
                            <label
                              className="text-sm text-gray-500"
                              htmlFor="name"
                            >
                              Enter name
                            </label>
                            <input
                              className="appearance-none block w-full placeholder:text-sm text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              id="name"
                              type="text"
                              placeholder="e.g marketing"
                              name="name"
                              autoComplete="off"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                            />
                            <p className="text-red-500 text-sm mt-2">
                              {formik.errors.name
                                ? formik.errors.name
                                : ""}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-6 flex justify-between">
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="bg-primary-800 hover:bg-primary-900 text-white py-2 px-4 rounded text-sm"
                    >
                      {loading ? <LoadingSpinner /> : "Create"}
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
